import { __awaiter, __generator } from "tslib";
import { CreationError, } from '@office-start/create-types';
import { FileType } from '@office-start/document-types';
import { getOriginParam } from '@office-start/file-utility';
import { isValidUrl } from '@office-start/url-parser-utility';
import { getDocAspxApiUrl } from './getDocAspxApiUrl';
export function getDocAspxFormActionUrlAndToken(_a) {
    var _b, _c;
    var candidate = _a.candidate, options = _a.options, startTime = _a.startTime, template = _a.template, enterpriseDriveId = _a.enterpriseDriveId, prefetchedToken = _a.prefetchedToken;
    return __awaiter(this, void 0, void 0, function () {
        var originParam, docAspxForPpeEnabled, apiUrl, accessToken, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!candidate ||
                        !candidate.docAspxId ||
                        !options.componentContext ||
                        !options.userEntitlements) {
                        throw new CreationError('Invalid docaspx params', "Error" /* CreateDocumentResultType.Error */);
                    }
                    originParam = getOriginParam(options.componentContext.workload, options.componentContext.router.getCurrentRoute(), candidate.createDocAspxEnabled, !!template);
                    docAspxForPpeEnabled = ((_c = (_b = options.featureGates) === null || _b === void 0 ? void 0 : _b.docAspxForPpeGates) === null || _c === void 0 ? void 0 : _c.docAspxForPpeEnabled) &&
                        candidate.fileType === FileType.Word;
                    apiUrl = getDocAspxApiUrl(candidate.docAspxId, originParam, startTime, options, template ? template.AssetId : undefined, enterpriseDriveId, docAspxForPpeEnabled);
                    if (!isValidUrl(apiUrl)) {
                        throw new CreationError('Invalid docaspxApiUrl', "Error" /* CreateDocumentResultType.Error */);
                    }
                    if (!(prefetchedToken !== undefined)) return [3 /*break*/, 1];
                    _d = prefetchedToken;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, options.componentContext.getAccessToken('OneDrive', false, options.userEntitlements.OneDriveResourceId)];
                case 2:
                    _d = _e.sent();
                    _e.label = 3;
                case 3:
                    accessToken = _d;
                    if (!accessToken || !accessToken.success) {
                        throw new CreationError('Invalid accessToken', "Error" /* CreateDocumentResultType.Error */);
                    }
                    return [2 /*return*/, { apiUrl: apiUrl, accessToken: accessToken }];
            }
        });
    });
}
//# sourceMappingURL=getDocAspxFormActionUrlAndToken.js.map